// extracted by mini-css-extract-plugin
export default {"container":"DeviceDeployment_container__SCpSm","deployCell":"DeviceDeployment_deployCell__oTOSH","gaugeImage":"DeviceDeployment_gaugeImage__VMs4B"};